<template>
  <div class="w-full pt-20">
    <div class="mx-auto pt-12 pb-20" style="width: 760px">
      <section>
        <h3 class="mt-2 mb-2 font-semibold text-xl">企業</h3>
        <ul v-if="state.company.id">
          <li class="bg-white rounded-lg mb-2">
            <router-link
              :to="{ name: 'Company', params: { companyId: state.company.id } }"
            >
              <div class="flex px-4 py-5">
                <div class="mr-4">
                  <img src="@/assets/icons/CompanyRed.svg" alt="" />
                </div>
                <div class="font-semibold text-gray-92">
                  {{ state.company.name }}
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </section>
      <section class="mt-8 mb-4">
        <h3 class="mt-4 mb-2 font-semibold text-xl">サービス</h3>
        <ul>
          <li v-for="service in state.services" :key="'service' + service.id">
            <div
              class="mb-2 relative cursor-pointer"
              @mouseover="state.hoveringServiceId = service.id"
              @mouseleave="state.hoveringServiceId = 0"
            >
              <div
                class="flex items-center justify-between bg-white rounded-lg"
              >
                <router-link
                  :to="{ name: 'Service', params: { serviceId: service.id } }"
                >
                  <div
                    class="flex justify-between items-center px-4 py-5"
                    style="height: 64px; width: 760px"
                  >
                    <div class="flex flex-row items-center">
                      <div class="mr-1 w-40 text-xs">
                        {{ service.category_class_name }}
                      </div>
                      <div class="font-semibold text-gray-92">
                        {{ service.category_name }}
                      </div>
                    </div>
                    <div class="flex items-center">
                      <div v-if="service.is_published === 1">
                        <div
                          v-if="
                            service.is_stopped === 0 &&
                            service.is_stop_requested === 0
                          "
                          class="flex flex-row"
                        >
                          <img
                            style="width: 17px"
                            src="@/assets/icons/EyeGreen.svg"
                            alt=""
                          />
                          <span class="text-sm text-green ml-1">公開中</span>
                        </div>
                        <div
                          v-if="
                            service.is_stopped === 0 &&
                            service.is_stop_requested === 1
                          "
                          class="flex flex-row"
                        >
                          <img
                            style="width: 17px"
                            src="@/assets/icons/EyeBlue.svg"
                            alt=""
                          />
                          <span class="text-sm text-blue ml-1"
                            >非公開申請中</span
                          >
                        </div>
                        <div
                          v-else-if="service.is_stopped === 1"
                          class="flex flex-row"
                        >
                          <span class="mr-5" v-if="service.stop_expire_on">
                            {{ service.stop_expire_on }}まで非公開
                          </span>
                          <img
                            style="width: 17px"
                            src="@/assets/icons/EyeSlash.svg"
                            alt=""
                          />
                          <span class="text-sm ml-1">非公開</span>
                        </div>
                      </div>
                      <div
                        v-if="
                          (isShowNewPlan &&
                            service.is_stopped === 0 &&
                            service.is_stop_requested === 0) ||
                          (!isShowNewPlan &&
                            service.is_published === 1 &&
                            service.is_stop_requested === 0)
                        "
                        class="w-12 px-4 py-5 focus:outline-none"
                        @click.prevent="state.clickingServiceId = service.id"
                      >
                        <img
                          v-show="
                            service.id == state.hoveringServiceId ||
                            service.id == state.clickingServiceId
                          "
                          class="w-4 h-4"
                          src="@/assets/icons/Ellipsis.svg"
                          alt=""
                        />
                      </div>
                      <div v-else class="w-12 px-4 py-5"></div>
                    </div>

                    <div
                      v-if="isShowNewPlan"
                      v-show="service.id == state.clickingServiceId"
                      class="absolute top-8 right-0 bg-white box-border rounded-lg z-50"
                      style="
                        top: 50px;
                        width: 200px;
                        height: 42px;
                        right: -100px;
                        box-shadow: 0 0 8px rgba(152, 163, 190, 0.3);
                        display: flex;
                        align-items: center;
                      "
                    >
                      <div
                        v-for="(option, key) in state.serviceStateSettingData
                          .options"
                        :key="key"
                      >
                        <div
                          v-if="service.is_stopped === option.id"
                          class="relative text-left leading-7 box-border text-gray-62 hover:text-gray-92 hover:bg-slate-100"
                          style="padding: 1px 16px 2px; width: 200px"
                          @click.prevent="openDialog(service.id, option.id)"
                        >
                          <span>{{ option.name }}</span>
                        </div>
                      </div>
                    </div>
                    <div
                      v-else
                      v-show="service.id == state.clickingServiceId"
                      class="absolute top-8 right-0 bg-white box-border rounded-lg z-50"
                      style="
                        top: 50px;
                        width: 200px;
                        height: 126px;
                        right: -100px;
                        box-shadow: 0 0 8px rgba(152, 163, 190, 0.3);
                      "
                    >
                      <div
                        class="relative text-left leading-7 box-border px-4 pt-2 py-3"
                        style="border-bottom: 1px solid #f1f2f6"
                      >
                        <span class="text-gray-92 font-semibold">{{
                          state.serviceStateSettingData.title
                        }}</span>
                      </div>
                      <div
                        v-for="(option, key) in state.serviceStateSettingData
                          .options"
                        :key="key"
                      >
                        <div
                          v-if="service.is_stopped === option.id"
                          class="relative text-left leading-7 box-border text-gray-62 hover:text-gray-92 hover:bg-slate-100"
                          style="padding: 1px 16px 2px"
                          @click.prevent="openDialog(service.id, option.id)"
                        >
                          <span>{{ option.name }}</span>
                        </div>
                        <div
                          v-else
                          class="relative text-left leading-7 box-border text-gray-38"
                          style="padding: 1px 16px 2px"
                        >
                          <span>{{ option.name }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </li>
        </ul>
      </section>

      <div
        v-show="state.clickingServiceId > 0"
        class="fixed inset-0 z-40"
        @click="state.clickingServiceId = 0"
      ></div>

      <div
        v-if="isShowNewPlan"
        class="text-left ml-4"
        style="text-indent: -1em"
      >
        <p class="text-gray-92 text-sm">
          ※サービスの新規追加や、非公開中サービスの再公開を希望される場合は、<br />
          画面右下のチャットサポートよりお申し込みください。
        </p>
      </div>
      <div v-else class="text-left">
        <p class="text-gray-92 text-sm">
          ※ カテゴリ追加のお申込みは、右下のチャット問合せよりご連絡ください
        </p>
      </div>
    </div>

    <ModalDialog
      :show-dialog="state.dialog.isShow"
      :title="state.dialog.title"
      title-class="text-base"
      close-text="キャンセル"
      close-text-border-class="border"
      close-text-color-class="text-gray-62"
      close-text-bg-class="bg-white"
      :ok-text="state.dialog.okText"
      ok-text-color-class="text-white"
      ok-text-bg-class="bg-coral-main"
      @ok-action="changeState()"
      @close-dialog="cancelChangeState()"
    >
      <div v-if="state.dialog.settingState === 0" class="mt-10 mb-6">
        <div class="pb-4">
          <div class="font-semibold text-gray-92 my-2">
            非公開理由<span
              class="ml-2 text-coral-main font-semibold"
              style="font-size: 11px"
              >必須</span
            >
          </div>
          <textarea
            class="block min-w-full px-4 py-3 border resize-none rounded"
            style="height: 112px; line-height: 18px"
            :class="
              state.errors.reasonError ? 'border-danger' : 'border-gray-38'
            "
            v-model="state.dialog.serviceStopReason"
          ></textarea>
          <span v-show="state.errors.reasonError" class="text-danger">{{
            state.errors.reasonErrorMsg
          }}</span>
        </div>
        <div class="font-semibold text-gray-92 my-2">再公開日</div>
        <input
          type="date"
          class="block min-w-full px-4 py-3 font-light border rounded leading-4"
          :class="state.errors.dateError ? 'border-danger' : 'border-gray-38'"
          v-model="state.dialog.stopExpireOn"
          :min="state.dialog.minDate"
          :max="state.dialog.maxDate"
        />
        <span v-show="state.errors.dateError" class="text-danger">{{
          state.errors.dateErrorMsg
        }}</span>
      </div>
    </ModalDialog>
  </div>
</template>

<script>
import { reactive, onMounted, inject, computed } from 'vue';
import axios from '@/utils/axiosAuth.js';
import ModalDialog from '@/components/modalDialog.vue';

export default {
  components: {
    ModalDialog,
  },
  setup() {
    const globalMethods = inject('globalMethods');

    const state = reactive({
      companies: [],
      company: {},
      companyId: null,
      services: [],
      hoverListFlag: false,
      hoveringServiceId: 0,
      clickingServiceId: 0,
      dialog: {
        isShow: false,
        serviceId: 0,
        title: '',
        content: '',
        settingState: '',
        stopExpireOn: null,
        serviceStopReason: '',
        okText: '',
        minDate: computed(() => {
          let tommorow = new Date();
          tommorow.setDate(tommorow.getDate() + 1);
          return tommorow.toISOString().split('T')[0];
        }),
        maxDate: computed(() => {
          let after6Months = new Date();
          after6Months.setMonth(after6Months.getMonth() + 6);
          return after6Months.toISOString().split('T')[0];
        }),
      },
      errors: {
        dateError: false,
        dateErrorMsg: '',
        reasonError: false,
        reasonErrorMsg: '',
      },
      serviceStateSettingData: {
        title: '公開設定',
        options: [
          {
            id: 1,
            name: '公開',
          },
          {
            id: 0,
            name: '非公開申請',
          },
        ],
      },
    });

    onMounted(async () => {
      await axios
        .get('/sellers')
        .then((response) => {
          state.companyId = response.data.data[0].company_id;
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'エラーが発生しました。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });
      await axios
        .get(`/companies/` + state.companyId)
        .then((response) => {
          state.company = response.data.data;
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'エラーが発生しました。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });
      await axios
        .get('/services')
        .then((response) => {
          state.services = response.data.data;
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'エラーが発生しました。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });
    });

    const openDialog = (serviceId, serviceState) => {
      if (serviceState === 0) {
        state.dialog.title =
          '非公開にして新規見積もりの受付を停止します。よろしいですか？';
        state.dialog.okText = '非公開申請';
      } else if (serviceState === 1) {
        state.dialog.title =
          '公開して新規見積もりの受付を再開します。よろしいですか？';
        state.dialog.okText = '公開にする';
      }
      state.dialog.isShow = true;
      state.dialog.settingState = serviceState;
      state.dialog.serviceId = serviceId;
    };

    const changeState = async () => {
      let apiPath;
      if (state.dialog.settingState === 0) {
        validateInput();
        apiPath = `/services/${state.dialog.serviceId}/request-stops/register`;
      } else {
        apiPath = `/services/${state.dialog.serviceId}/stops/delete`;
      }
      if (!state.errors.dateError && !state.errors.reasonError) {
        let postData = {};
        if (state.dialog.settingState === 0) {
          postData = {
            serviceStopReason: state.dialog.serviceStopReason,
            stopExpireOn: state.dialog.stopExpireOn,
          };
        }
        await axios
          .post(apiPath, postData)
          .then(async () => {
            // サービス更新
            state.services.forEach(function (s) {
              if (s.id == state.dialog.serviceId) {
                if (state.dialog.settingState === 0) {
                  s.is_stop_requested = 1;
                } else {
                  s.is_stopped = 0;
                }
                return;
              }
            });
          })
          .catch((e) => {
            globalMethods.updateModal(
              true,
              'リクエストが完了しませんでした。',
              e.systemMessage || '',
              e.callback
            );
            globalMethods.sendLog(e);
          });
        state.dialog.serviceStopReason = '';
        state.dialog.stopExpireOn = null;
        state.dialog.isShow = false;
        state.clickingServiceId = 0;
      }
    };

    const cancelChangeState = () => {
      state.dialog.serviceStopReason = '';
      state.dialog.isShow = false;
      state.clickingServiceId = 0;
      state.dialog.stopExpireOn = null;
      state.errors.dateError = false;
      state.errors.reasonError = false;
    };

    const validateInput = () => {
      if (state.dialog.serviceStopReason == '') {
        state.errors.reasonErrorMsg = '非公開理由を入力してください。';
        state.errors.reasonError = true;
      } else {
        state.errors.reasonError = false;
      }
      if (state.dialog.stopExpireOn) {
        const stopExpireOn = Date.parse(state.dialog.stopExpireOn);
        const today = new Date();
        const after6Months = new Date();
        after6Months.setMonth(after6Months.getMonth() + 6);

        if (isNaN(stopExpireOn)) {
          state.errors.dateErrorMsg = '年/月/日形式で入力してください。';
          state.errors.dateError = true;
        } else if (today >= stopExpireOn) {
          state.errors.dateErrorMsg = '明日以降の日を入力してください。';
          state.errors.dateError = true;
        } else if (after6Months < stopExpireOn) {
          state.errors.dateErrorMsg =
            '6ヶ月以内の非公開終了日を入力してください。';
          state.errors.dateError = true;
        } else {
          state.errors.dateError = false;
        }
      }
    };
    const isShowNewPlan = process.env.VUE_APP_IS_NEW_PLAN === 'true';

    return {
      state,
      openDialog,
      changeState,
      cancelChangeState,
      isShowNewPlan,
    };
  },
};
</script>
